var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-icon',{attrs:{"small":""}},[_vm._v("train")]),_vm._v(" "+_vm._s(_vm.vehicle.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }